import { FormBlockerElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'

import { CollapsibleRowElement, isCollapsibleRow } from './CollapsibleSection'

export function getCollapsibleSectionRows(elements: FormBlockerElement[], startIndex: number): CollapsibleRowElement[] {
  const firstRow = elements[startIndex]
  if (!isCollapsibleRow(firstRow)) return []

  const sectionId = firstRow.cell_default_element.collapsible_presentation?.section_id
  const rows: CollapsibleRowElement[] = []
  for (let index = startIndex; index < elements.length; index += 1) {
    const row = elements[index]
    if (!isCollapsibleRow(row) || row.cell_default_element.collapsible_presentation?.section_id !== sectionId) break
    rows.push(row)
  }
  return rows
}
